import { ModbusFunctionCodeEnum } from '@sb/integrations/utils/modbus/ModbusFunctionCode';

import type { ModbusTCPRegisterData } from './types';

export const ONROBOT_TCP_PORT_DEFAULT = 502;

export const TCP_CONNECTION_TIMEOUT_MS_DEFAULT = 5_000;

// The name is given as "client" here to reduce customer confusion, since our robot
// will be the client even though it is connecting to the server. All the backend
// code will still refer to it as a server.
export const MODBUS_TCP_SERVER_NAME_DEFAULT = 'Modbus TCP Client';

export const MODBUS_TCP_SERVER_REGISTER_FORMAT_DEFAULT = 'UInt16BE';

export const MODBUS_TCP_SERVER_REGISTER_DEFAULT: ModbusTCPRegisterData = {
  id: '',
  name: '',
  type: 'holdingRegister',
  offset: 0,
  format: MODBUS_TCP_SERVER_REGISTER_FORMAT_DEFAULT,
};

export const modbusCodeList = [
  {
    name: 'Read Coils',
    code: ModbusFunctionCodeEnum.ReadCoils,
  },
  {
    name: 'Read Discrete Inputs',
    code: ModbusFunctionCodeEnum.ReadDiscreteInputs,
  },
  {
    name: 'Read Holding Registers',
    code: ModbusFunctionCodeEnum.ReadHoldingRegisters,
  },
  {
    name: 'Read Input Registers',
    code: ModbusFunctionCodeEnum.ReadInputRegisters,
  },
  {
    name: 'Write Coils',
    code: ModbusFunctionCodeEnum.WriteSingleCoil,
  },
  {
    name: 'Write HoldingRegisters',
    code: ModbusFunctionCodeEnum.WriteSingleRegister,
  },
];
